import { Filter } from "lucide-react";
import { useTranslation } from "react-i18next";

const UnderstandingEntitiesAttributes = () => {
  const { t } = useTranslation();

  const darkBlue = "rgb(16, 53, 100)";
  const lightBlue = "rgb(1, 184, 239)";

  return (
    <div className="min-h-screen bg-white py-12 px-4">
      <div className="max-w-4xl mx-auto text-center">
        {/* Content Card */}
        <div
          className="bg-white rounded-3xl p-8 md:p-12 shadow-2xl border-2"
          style={{
            borderColor: lightBlue,
            boxShadow: `0 25px 50px -12px rgba(1, 184, 239, 0.15)`,
          }}
        >
          <div
            className="inline-flex items-center justify-center w-24 h-24 rounded-full text-white mb-8 shadow-lg"
            style={{ backgroundColor: lightBlue }}
          >
            <Filter className="w-12 h-12" />
          </div>

          <h2
            className="text-3xl md:text-4xl font-bold mb-3"
            style={{ color: darkBlue }}
          >
            {t("UnderstandingEntities.title")}
          </h2>
          <h3
            className="text-xl font-semibold mb-6"
            style={{ color: lightBlue }}
          >
            {t("UnderstandingEntities.subtitle")}
          </h3>
          <p
            className="text-lg leading-relaxed max-w-2xl mx-auto mb-8"
            style={{ color: darkBlue, opacity: 0.8 }}
          >
            {t("UnderstandingEntities.description")}
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnderstandingEntitiesAttributes;
